var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remain_ticket_continer"},[_c('span',{staticClass:"left_tip size_34"},[_vm._v("今日免费门票剩余")]),_c('remainTicketNum'),_c('span',{staticClass:"left_tip size_34"},[_vm._v("张")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }